import { Pipe, PipeTransform } from '@angular/core';
import { Name } from '@app/domain/model/name';

@Pipe({
  name: 'name'
})
export class DisplayNamePipe implements PipeTransform {

  transform(name: Name, args?: any): string {
    return name ? [name.firstName, name.middleName, name.lastName, name.suffix].filter(candidate => null != candidate).join(' ') : null;
  }

}
